<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="BP/预测 数据导入"
      width="80%"
      top="6vh"
      append-to-body>
    <div style="margin-bottom: 10px; display: flex; align-items: center; gap: 8px">
      <el-button type="primary" size="mini" @click="downloadTemplate">下载导入模板</el-button>
      <el-upload
          :action="uploadUrl"
          :headers="uploadHeaders"
          :before-upload="beforeAvatarUpload"
          :on-success="handleSuccess"
          :on-error="handlerError"
          :on-progress="onProgress"
          :show-file-list="false"
          accept=".xlsx"
          style="display: inline-block">
        <el-button :loading="importLoading" type="primary" size="mini">导入Excel</el-button>
      </el-upload>
    </div>
    <vm-table
        ref="vmTable"
        :filter.sync="bpFilter"
        module="basic"
        url="sd/salesRevenueReport/bpData">
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="数据类别">
            <el-select v-model="bpFilter.dataType" clearable placeholder="请选择" style="width: 130px">
              <el-option :value="1" label="BP"/>
              <el-option :value="2" label="预测"/>
            </el-select>
          </vm-search>
          <vm-search label="组织名称">
            <el-input v-model.trim="bpFilter.departmentName" readonly>
              <el-button slot="append" icon="el-icon-search" @click="$refs.selectDepartment.open()">选择</el-button>
            </el-input>
            <department-select ref="selectDepartment" @select="selectDepartment"/>
          </vm-search>
          <vm-search label="开始期间">
            <el-date-picker v-model="bpFilter.beginTime" value-format="yyyy-MM-dd" type="month" style="width: 130px"/>
          </vm-search>
          <vm-search label="结束期间">
            <el-date-picker v-model="bpFilter.endTime" value-format="yyyy-MM-dd" type="month" style="width: 130px"/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="dataTypeName" align="center" label="数据类别" width="100"/>
      <el-table-column prop="departmentName" align="center" label="组织名称" min-width="140"/>
      <el-table-column prop="periodDate" align="center" label="期间" width="120"/>
      <el-table-column prop="amount" align="center" label="金额（万元）" width="140"/>
      <el-table-column label="操作" align="center" width="100">
        <template slot-scope="scope">
          <el-button size="mini" type="danger" @click="remove(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </vm-table>
  </el-dialog>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import DepartmentSelect from "@/views/information/Department/DepartmentSelect";
  import loginUtil from "@/util/loginUtil";

  export default {
    name: "BpImportDialog",
    components: {VmTable, VmSearch, DepartmentSelect},
    data() {
      return {
        dialogVisible: false,
        importLoading: false,
        uploadUrl: window.config.basicServerUrl + "sd/salesRevenueReport/importBpExcel",
        uploadHeaders: {"Authorization": loginUtil.getToken()},
        bpFilter: {
          dataType: "",
          departmentId: "",
          departmentName: "",
          beginTime: "",
          endTime: "",
        },
      };
    },
    methods: {
      open() {
        this.bpFilter = {
          dataType: "",
          departmentId: "",
          departmentName: "",
          beginTime: "",
          endTime: "",
        };
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.vmTable.getList(1);
        });
      },
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      selectDepartment(row) {
        this.bpFilter.departmentId = row.departmentID;
        this.bpFilter.departmentName = row.departmentName;
      },
      downloadTemplate() {
        window.open("/publicFile/BP预测导入模板.xlsx");
      },
      beforeAvatarUpload(file) {
        let fileName = file.name;
        let pos = fileName.lastIndexOf(".");
        let lastName = fileName.substring(pos, fileName.length);
        if (lastName.toLowerCase() !== ".xlsx") {
          this.$message.error("请上传.xlsx文件类型");
        }
      },
      onProgress() {
        this.importLoading = true;
      },
      handleSuccess() {
        this.importLoading = false;
        this.$message.success("导入成功");
        this.getList(1);
      },
      handlerError(err) {
        this.importLoading = false;
        try {
          err = JSON.parse(err.message);
          this.$message.error(err.message || "导入失败");
        } catch (e) {
          this.$message.error("导入失败");
        }
      },
      remove(row) {
        this.$confirm("确定删除该条数据吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .post("basic", "sd/salesRevenueReport/deleteBpData", null, {pkid: row.pkid})
            .then(resp => {
              if (resp && resp.success === false) {
                return this.$message.error(resp.message || "删除失败");
              }
              this.$message.success("删除成功");
              this.getList(1);
            });
        }).catch(() => {});
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
